import { Maybe, PageSlicesSurvey_Slice } from 'prismic-types';
import SliceContainer from 'containers/slices/SliceContainer';
import IframeResizer from 'iframe-resizer-react';
import { useRef } from 'react';

import styles from './SurveySlice.module.scss';
import cx from 'classnames';

export const SurveySlice = ({
  halfWidth,
  slideUp,
}: {
  halfWidth?: Maybe<boolean>;
  slideUp?: Maybe<boolean>;
}) => {
  const isSmall = halfWidth;
  const slideUpClass = slideUp;
  const iframeRef = useRef<HTMLDivElement>(null);
  return (
    <SliceContainer removeDefaultPadding className={styles.lessSpacing}>
      <div ref={iframeRef}>
        <IframeResizer
          className={cx(styles.frame, {
            [styles.small]: isSmall,
            [styles.slideUp]: slideUpClass,
          })}
          src="/survey.html"
          checkOrigin={false}
          inPageLinks={true}
          heightCalculationMethod="taggedElement"
        />
      </div>
    </SliceContainer>
  );
};

export function prismicSliceToSurveySlice(s: PageSlicesSurvey_Slice) {
  return (
    <SurveySlice
      halfWidth={s.variation?.primary?.half_width}
      slideUp={s.variation?.primary?.slide_up}
    />
  );
}
